import { useEffect, useState } from "react";
import type { ChangeEvent } from "react";
import { Loader2, Save } from "lucide-react";
import {
  CertificationButton,
  CertificationInputField,
  CertificationModal,
  CertificationTextareaField,
} from "../../ui";
import type {
  ManualSistemaIntegradoControlModificacion,
  ManualSistemaIntegradoControlPayload,
} from "../types/manual-sistema-integrado";

type Props = {
  open: boolean;
  row: ManualSistemaIntegradoControlModificacion | null;
  submitting: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (payload: ManualSistemaIntegradoControlPayload) => void;
};

export function ManualSistemaIntegradoControlModificacionFormModal({
  open,
  row,
  submitting,
  error,
  onClose,
  onSubmit,
}: Props) {
  const [fecha, setFecha] = useState("");
  const [modificaciones, setModificaciones] = useState("");

  useEffect(() => {
    if (!open) return;
    setFecha(row?.fecha ?? "");
    setModificaciones(row?.modificaciones_realizadas ?? "");
  }, [open, row]);

  const valid = fecha.trim() !== "" && modificaciones.trim() !== "";

  return (
    <CertificationModal
      open={open}
      title={row ? "Editar modificación" : "Nueva modificación"}
      eyebrow="Control documental"
      description="Registra la fecha y el detalle de la modificación del manual."
      onClose={onClose}
      onSubmit={() => {
        if (!valid) return;
        onSubmit({
          fecha: fecha.trim(),
          modificaciones_realizadas: modificaciones.trim(),
        });
      }}
      submitting={submitting}
      error={error}
      closeOnBackdrop={false}
      footer={
        <>
          <CertificationButton variant="secondary" onClick={onClose} disabled={submitting}>
            Cancelar
          </CertificationButton>
          <CertificationButton
            type="submit"
            variant="primary"
            icon={submitting ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />}
            disabled={!valid || submitting}
          >
            Guardar
          </CertificationButton>
        </>
      }
    >
      <div className="manual-si-shared-form-grid manual-si-shared-form-grid-single">
        <CertificationInputField
          label="Fecha"
          type="text"
          value={fecha}
          maxLength={50}
          disabled={submitting}
          onChange={(event: ChangeEvent<HTMLInputElement>) => setFecha(event.target.value)}
          placeholder="Ej. 06/10/2025"
          fullWidth
        />
        <CertificationTextareaField
          label="Modificaciones realizadas"
          value={modificaciones}
          rows={6}
          disabled={submitting}
          onChange={(event: ChangeEvent<HTMLTextAreaElement>) => setModificaciones(event.target.value)}
          fullWidth
        />
      </div>
    </CertificationModal>
  );
}
